// Shared "marketing scripts may load now" trigger.
//
// The inline script at the top of index.html registers the trigger: the
// visitor's first pointerdown / keydown / touchstart / scroll, or 4 s after
// window load if they never interact. Ad-pixel libraries (Meta, TikTok,
// Reddit, ChatGPT Ads, Microsoft UET, Brevo, Klaviyo) download only then, so
// they don't compete with the first tap. Their queue stubs exist from the
// start, so events fired earlier wait and are sent once the libraries arrive.

declare global {
  interface Window {
    /** Runs the callback once marketing scripts may load (immediately if already allowed). */
    __whenMarketing?: (cb: () => void) => void;
    /** Fires the trigger now (idempotent). */
    __loadMarketingNow?: () => void;
  }
}

/** Runs `load` when marketing libraries may download. */
export function whenMarketingMayLoad(load: () => void): void {
  if (typeof window === "undefined") return;
  if (typeof window.__whenMarketing === "function") window.__whenMarketing(load);
  else load(); // Template without the trigger script: keep the old behaviour.
}

/** Downloads every waiting marketing library now (e.g. on a conversion). */
export function loadMarketingNow(): void {
  try {
    window.__loadMarketingNow?.();
  } catch {
    // Analytics must never break the app.
  }
}
